var $ = jQuery;

/**
 * Sends ajax request to save the edits on the image.
 * @returns Nothing.
 */
export const SaveEdits = async (fileName = '', title = '') => {
    try {
        const attachment = getAttachment();
        const editedImage = getImgBlob();

        if (!(editedImage instanceof Blob)) {
            console.error('Edited image is not a valid Blob.');
            return false;
        }
        if (!attachment || !attachment.id) {
            console.error('Attachment was not found or is invalid.');
            return false;
        }

        let saveAsNew = 'yes';
        if (fileName === '') {
            fileName = attachment.filename;
            saveAsNew = 'no';
        }

        const mimeType = editedImage.type;
        const fileExtension = mimeType.split('/')[1];
        const originalExtension = attachment.filename.split('.').pop();
        if (saveAsNew === 'no' && fileExtension !== originalExtension) {
            fileName = `${attachment.filename.replace(/\.[^/.]+$/, '')}.${fileExtension}`;
        }

        const file = new File([editedImage], fileName, { type: mimeType });
        const formData = new FormData();
        formData.append('action', 'smartmt_save_edits');
        formData.append('attachmentId', attachment.id);
        formData.append('file', file);
        formData.append('saveAsNew', saveAsNew);
        formData.append('title', title);
        formData.append('security', smartmt_vars.nonce);

        const response = await fetch(ajaxurl, { method: 'POST', body: formData });

        if (!response.ok) {
            throw new Error(`Failed to save edits: ${response.statusText}`);
        }

        const data = await response.json();

        if (data.status === 'success') {
            const newImageUrl = data.attachment_url;
            $('#smartmt-editor-popup').remove();
            $('#smartmt-alert').remove();

            if (saveAsNew === 'no') {
                wp.media.attachment(attachment.id).fetch().then(() => {
                    const newUrl = attachment.get('url') + '?t=' + Date.now();
                    attachment.set('url', newUrl);

                    wp.media.frame.state().props.trigger('change:attachment', attachment);

                    wp.media.frame.content.mode('browse');
                    wp.media.frame.content.get().collection.props.set({ ignore: Date.now() });
                    wp.media.frame.content.get().collection.reset();
                    wp.media.frame.content.get().collection.fetch({ reset: true });

                    const selection = wp.media.frame.state().get('selection');
                    if (selection) {
                        const updatedAttachment = wp.media.attachment(attachment.id);
                        updatedAttachment.fetch().then(() => {
                            selection.reset([updatedAttachment]);
                        });
                    }
                });
            }
            if (!wp.media.frame._state || wp.media.frame._state !== 'featured-image') {
                window.location.href = data.media_library_url;
            }


        } else {
            window.location.href = data.redirect;
        }
    } catch (error) {
        console.error('Error saving edits:', error);
        return false;
    }
};

/**
 * Get blob image's temporary URL.
 * @param {blob} blobImg 
 * @returns Temp url of the image.
 */
export const getBlobUrl = (blobImg) => (blobImg instanceof Blob) ? URL.createObjectURL(blobImg) : false;

/**
 * Validates file name on save as.
 * @param {string} fileName New name for the image
 * @returns Validated file name.
 */
export const validateImageFileName = (fileName) => {

    // Replace everything except letters, numbers, "_" and "-" with "-"
    let validatedName = fileName.replace(/[^a-zA-Z0-9_-]/g, '-');

    // Remove duplicate "-"s
    validatedName = validatedName.replace(/-+/g, '-');

    // Remove "-"s from the start and end
    validatedName = validatedName.replace(/^-+|-+$/g, '');

    // Add the file extension
    validatedName += getFileExtension();
    $('#smart-mt-validated-new-name').val(validatedName);
};

/**
 * Get attachment object from localstorage.
 * @returns Attachment JSON object.
 */
export const getAttachment = () => { return JSON.parse(localStorage.getItem('smart-mt-attachment')); };

export const getFileExtension = () => {
    const mimeType = getCurrentMimeType();
    return `.${mimeType.split('/')[1]}`;
};

/**
 * Genral function to show Successfully applied
 * 
 */
export function showToastMessage(message, type) {
    const toast = document.createElement("div");
    toast.className = `wp-core-ui smartmt toast-message ${type}`;
    toast.innerText = message;

    document.body.appendChild(toast);

    setTimeout(() => {
        toast.classList.add("visible");
    }, 100);

    setTimeout(() => {
        toast.classList.remove("visible");
        setTimeout(() => {
            toast.remove();
        }, 500);
    }, 3000);
}

/**
 * Genral function to set dinamicly mime type
 * 
 */
export const getCurrentMimeType = () => {
    const currentBlob = getImgBlob();
    return currentBlob ? currentBlob.type : getAttachment().mime;
};

export const setImgBlob = (blob) => {
    if (!blob) { return; }

    // Ensure the global blob array exists.
    if (!window.SmartMT.imgBlob || !Array.isArray(window.SmartMT.imgBlob)) {
        window.SmartMT.imgBlob = [];
    }

    // Append the new blob.
    window.SmartMT.imgBlob.push(blob);

    // lastAppliedIndex always points to the most recent edit.
    window.SmartMT.lastAppliedIndex = window.SmartMT.imgBlob.length - 1;
    // currentIndex is also set to the latest edit, so undo/redo starts from here.
    window.SmartMT.currentIndex = window.SmartMT.lastAppliedIndex;

    updateBtnStatus(window.SmartMT.imgBlob);
};

export const clearHistory = () => {
    window.SmartMT.imgBlob = [];
    window.SmartMT.currentIndex = 0;
    window.SmartMT.lastAppliedIndex = 0;

    updateBtnStatus(window.SmartMT.imgBlob);
};

export const getImgBlob = () => {
    let imgBlob = window.SmartMT.imgBlob;
    let currentIndex = window.SmartMT.currentIndex;
    if (imgBlob && imgBlob.length > 0 && typeof currentIndex === 'number') {
        return imgBlob[currentIndex];
    }
    return false;
};

export const updateBtnStatus = (imgBlobs) => {

    const save = $('.smart-mt-confirm-save');
    const saveAs = $('.smart-mt-confirm-save-as');
    const undo = $('.smart-mt-undo');
    const redo = $('.smart-mt-redo');

    let currentIndex = window.SmartMT.currentIndex;

    if (imgBlobs.length > 0) {
        save.prop('disabled', false);
        saveAs.prop('disabled', false);
        undo.prop('disabled', false);
    }

    if (currentIndex < imgBlobs.length - 1) {
        redo.prop('disabled', false);
    }

    else {
        redo.prop('disabled', true);
    }

    if (currentIndex <= -1) {
        save.prop('disabled', true);
        saveAs.prop('disabled', true);
        undo.prop('disabled', true);
    }
};

let cropperInitializationFunction = null;

export const setCropperInitializationFunction = (initializationFunction) => {
    cropperInitializationFunction = initializationFunction;
};

const getCropperInitializationFunction = () => {
    return cropperInitializationFunction;
};

let currentMode = null;
let indexOnApply = null;


export const setCurrentMode = (mode) => {
    currentMode = mode;
};
const getCurrentMode = () => {
    return currentMode;
};
export const setIndexOnApply = (index) => {
    indexOnApply = index;
};
const getIndexOnApply = () => {
    return indexOnApply;
};

export const navigateEdits = (direction) => {
    const imageElement = document.getElementById('smartmt-edit-image');
    let imgBlobs = window.SmartMT.imgBlob;
    let currentIndex = window.SmartMT.currentIndex;
    let newIndex = direction === 'undo' ? currentIndex - 1 : currentIndex + 1;

    const currentIndexOnLocalStorage = +getIndexOnApply();
    if (currentIndexOnLocalStorage) {
        newIndex = currentIndexOnLocalStorage;
        setIndexOnApply(null);
    }

    let newBlob = null;
    let imgUrl = '';

    if (newIndex >= 0 && newIndex < imgBlobs.length) {
        newBlob = imgBlobs[newIndex];
        imgUrl = getBlobUrl(newBlob);
    } else if (newIndex < 0) {
        let imAttachment = localStorage.getItem('smart-mt-attachment');
        imgUrl = JSON.parse(imAttachment).url;
    }

    if (imgUrl) {
        if (window.SmartMT.cropper) {
            window.SmartMT.cropper.destroy();
            window.SmartMT.cropper = null;
        }

        imageElement.src = imgUrl;
        imageElement.onload = function () {
            const newWidth = this.naturalWidth;
            const newHeight = this.naturalHeight;

            $('#resizeWidth').val(newWidth);
            $('#resizeHeight').val(newHeight);
            $('#crop-width').val(newWidth);
            $('#crop-height').val(newHeight);

            let mode = getCurrentMode();
            if (mode === 'crop') {
                const initializeCropper = getCropperInitializationFunction();
                if (initializeCropper) {
                    initializeCropper(imageElement);
                }
            }

            if (mode !== 'crop') {
                window.SmartMT.croppedWidth = null;
                window.SmartMT.croppedHeight = null;
            }

            if (newBlob) {
                const sizeInKB = (newBlob.size / 1024).toFixed(2);
                if ($('#smartmt-options').is(':visible')) {
                    $('#compressed-size').text(`${sizeInKB} KB`);
                } else if ($('#iloveimage-size').is(':visible')) {
                    $('#iloveimage-compressed-size').text(`${sizeInKB} KB`);
                }
            }
        };

        window.SmartMT.currentIndex = newIndex;
        updateBtnStatus(imgBlobs);
    }
};